import { type UnreferencedImplantCharacteristics } from "@jasper/client-models";
import { Group, Input } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { FieldValueProps } from "../../types";

type Props = FieldValueProps<UnreferencedImplantCharacteristics>;

export const UnreferencedImplantCharacteristicsForm = ({
  value,
  errors,
  onChange,
}: Props) => {
  const { t } = useTranslation("forms", {
    keyPrefix: "forms.implantCharacteristics",
  });

  return (
    <Group>
      <Input.Wrapper
        flex={1}
        label={t("labels.implantBrand")}
        error={errors?.implantBrand ? t("errors.implantBrand") : undefined}
      >
        <Input
          placeholder={t("placeholders.implantBrand")}
          value={value?.implantBrand ?? ""}
          onChange={e => onChange({ ...value, implantBrand: e.target.value })}
          error={errors?.implantBrand ? t("errors.implantBrand") : undefined}
        />
      </Input.Wrapper>
      <Input.Wrapper
        flex={1}
        label={t("labels.implantSystem")}
        error={errors?.implantSystem ? t("errors.implantSystem") : undefined}
      >
        <Input
          placeholder={t("placeholders.implantSystem")}
          value={value?.implantSystem ?? ""}
          onChange={e => onChange({ ...value, implantSystem: e.target.value })}
          error={errors?.implantSystem ? t("errors.implantSystem") : undefined}
        />
      </Input.Wrapper>
      <Input.Wrapper
        flex={1}
        label={t("labels.implantPlatform")}
        error={
          errors?.implantPlatform ? t("errors.implantPlatform") : undefined
        }
      >
        <Input
          placeholder={t("placeholders.implantPlatform")}
          error={
            errors?.implantPlatform ? t("errors.implantPlatform") : undefined
          }
          value={value?.implantPlatform ?? ""}
          onChange={e =>
            onChange({ ...value, implantPlatform: e.target.value })
          }
        />
      </Input.Wrapper>
    </Group>
  );
};
